var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.simple)?_c('div',[_c('p',[_vm._v("-")])]):_c('div',{staticClass:"empty"},[_c('v-icon',{staticClass:"e-icon",attrs:{"size":"70"},domProps:{"textContent":_vm._s(_vm.icon)}}),_c('div',{staticClass:"e-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"e-text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }